module.exports = __webpack_public_path__ + "static/media/Board of Studies_2017-18.1fb183c3.pdf";